import { mode } from '@chakra-ui/theme-tools';

export const progressStyles = {
	components: {
		Progress: {
			baseStyle: {
				track: {
					borderRadius: '20px',
					_focus: {
						boxShadow: 'none'
					}
				}
			},
			variants: {
				table: (props: any) => ({
					filledTrack: {
						bg: 'brand.500',
						borderRadius: '16px'
					},
					track: {
						borderRadius: '20px',
						bg: mode('blue.50', 'whiteAlpha.50')(props),
						h: '8px'
					}
				})
			}
		}
	}
};
